import { X } from 'lucide-react'
import { useToastStore } from '../store/toastStore'

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts)
  const dismiss = useToastStore((s) => s.dismiss)

  if (!toasts.length) return null

  return (
    <div
      className="fixed bottom-4 right-4 z-[200] flex flex-col gap-2 max-w-sm w-[calc(100vw-2rem)] pointer-events-none"
      aria-live="polite"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className="pointer-events-auto flex items-start gap-3 rounded-xl border px-4 py-3 text-sm shadow-card"
          style={{
            background: '#FDFCF8',
            borderColor: t.variant === 'error' ? '#f5c2c2' : '#a7d8e0',
            color: t.variant === 'error' ? '#991b1b' : '#1a3a40',
          }}
          role="status"
        >
          <p className="flex-1 min-w-0 leading-snug">{t.message}</p>
          <button
            type="button"
            onClick={() => dismiss(t.id)}
            className="shrink-0 p-0.5 rounded text-ink-faint hover:text-ink hover:bg-warm-inset"
            aria-label="Dismiss notification"
          >
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  )
}
